<template>
  <div>
    <div id="AsignacionDePermisosParaVerEnVivo_div" class="w-100 px-5 py-4">
      <div id="TituloReasignacionDeOperadore_div">
        <h1>ASIGNACIÓN DE PERMISOS</h1>
        <h3>Control de asignación de permisos para ver audiencias en vivo</h3>
      </div>
      <div class="row d-flex">
        <div id="DespliegueVistaDeInformacion_div" class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <h2>Información</h2>
            <hr />
            <p><strong>Juzgado: </strong><br />{{Audiencia.Area.Nombre}}</p>
            <p><strong>Materia: </strong><br />{{Audiencia.Materia.Nombre}}</p>
            <p><strong>Tipo de documento: </strong><br />{{Audiencia.TipoDocumento.Nombre}}</p>
            <p><strong>Consecutivo: </strong><br />{{Audiencia.Consecutivo}}</p>
            <p><strong>Tipo de audiencia: </strong><br />{{Audiencia.TipoAudiencia.Nombre}}</p>
            <p><strong>Fecha: </strong><br />{{Audiencia.FechaAudiencia}}</p>
            <p><strong>Sala: </strong><br />{{Audiencia.Sala.Nombre}}</p>
            <p><strong>Estatus de la audiencia: </strong><br />{{Audiencia.TipoEstatusDeAudiencia.Nombre}}</p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <div>
              <h5>Permisos de acceso</h5>
              <hr />
              <h6>Buscar persona a autorizar</h6>
              <hr />
              <div style="display:flex">
                <button class="btn btn-primary col-6" @click="BuequedaPorNombre = true">Nombre</button>
                <button class="btn btn-primary col-6" @click="BuequedaPorNombre = false">Email</button>
              </div>
              <div class="row" id="nombre_div" v-if="BuequedaPorNombre">
                <div class="col-lg-4 col-md-3 col-sm-3">
                  <label for="Nombre">Nombre</label>
                  <input type="text" class="form-control" placeholder="Ingrese nombre" id="Nombre" v-model="Persona.Nombre" />
                </div>
                <div class="col-lg-4 col-md-3 col-sm-3">
                  <label for="ApellidoPaterno">Apellido paterno</label>
                  <input type="text" class="form-control" placeholder="Ingrese Apellido Paterno" id="ApellidoPaterno" v-model="Persona.ApellidoPaterno" />
                </div>
                <div class="col-lg-4 col-md-3 col-sm-3">
                  <label for="ApellidoMaterno">Apellido Materno</label>
                  <input type="text" class="form-control" placeholder="Ingrese ApellidoMaterno" id="ApellidoMaterno" v-model="Persona.ApellidoMaterno" />
                </div>
              </div>
              <div class="row" id="nombre_div" v-if="!BuequedaPorNombre">
                <div class="col-lg-12 col-md-3 col-sm-3">
                  <label for="Nombre">Email</label>
                  <input type="text" class="form-control" placeholder="Ingrese Email" id="Email" v-model="Persona.Email" />
                </div>
              </div>
              <div class="text-right">
                <br />
                <button class="btn btn-primary" v-on:click="limpiarDatos()">Limpiar</button>
                <button class="btn btn-primary" v-on:click="busquedaPersonas()">Buscar</button>
              </div>
              <h6>Personas encontradas</h6>
              <hr />
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Nombre</th>
                    <th class="text-center">Apellido paterno</th>
                    <th class="text-center">Apellido materno</th>
                    <th class="text-center">Usuario</th>
                    <th class="text-center">Agregar</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="persona in PersonasEncontradas" :key="persona.IdUsuario">
                    <td>{{persona.Nombre}}</td>
                    <td>{{persona.ApellidoPaterno}}</td>
                    <td>{{persona.ApellidoMaterno}}</td>
                    <td>{{persona.Email}}</td>
                    <td align="center"><i class="fas fa-plus-circle" v-on:click="darPermiso(persona)" title="Asignar permiso"></i></td>
                  </tr>
                </tbody>
              </table>
              <h6>Personas autorizadas</h6>
              <hr />
              <br />
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Nombre</th>
                    <th class="text-center">Apellido paterno</th>
                    <th class="text-center">Apellido materno</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">Quitar</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-for="persona in PersonasAutorizadas" :key="persona.IdUsuario">
                    <td>{{persona.Usuario.Nombre}}</td>
                    <td>{{persona.Usuario.ApellidoPaterno}}</td>
                    <td>{{persona.Usuario.ApellidoMaterno}}</td>
                    <td>{{persona.Usuario.Email}}</td>
                    <td align="center"><i class="fas fa-minus-circle" v-on:click="eliminarPermiso(persona.PermisoParaVerEnVivoId)" title="Eliminar permisos"></i></td>
                  </tr>
                </tbody>
              </table>
              <div class="text-right">
                <button class="btn btn-primary" v-on:click="finalizar">Finalizar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import router from '@/router/index'

  export default {
    data() {
      return {
        comun,
        enumeraciones,
        Audiencia: {
          AudienciaId: Number,
          Area: { Nombre: String },
          Materia: { Nombre: String },
          TipoAudiencia: {
            Nombre: String
          },
          TipoDocumento: {
            Nombre: String
          },
          Fecha: String,
          HoraDeInicio: String,
          HoraFinalizada: String,
          Jueces: [
            { Nombre: String }
          ],
          Sala: { Nombre: String },
          TipoEstatusDeAudiencia: {
            TipoEstatusDeAudienciaId: Number,
            Nombre: String
          }
        },
        BuequedaPorNombre: true,
        Persona: {
          Nombre: "",
          ApellidoPaterno: "",
          ApellidoMaterno: "",
          Email: ""
        },
        PersonasEncontradas: [],
        PersonasAutorizadas: [],
      }
    },
    props: {
      AudienciaId: Number
    },
    mounted() {
      if (this.AudienciaId != null && this.AudienciaId != undefined && this.AudienciaId > 0) {
        this.busquedaAudiencia();
      }
    },
    methods: {
      limpiarDatos() {
        this.PersonasEncontradas = [];
        this.Persona.Nombre = "";
        this.Persona.ApellidoPaterno = "";
        this.Persona.ApellidoMaterno = "";
        this.Persona.Email = "";        
      },
      finalizar() {
        router.push({ name: "PanelDeAudienciasParaAsignacionDePermisosParaVerEnVivo" });
      },
      eliminarPermiso(PermisoParaVerEnVivoId) {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          PermisoParaVerEnVivoId: PermisoParaVerEnVivoId,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(api.conexion + api.Forseti.sistema.administracion.asignacionDePermisosParaVerEnVivo.EliminararPermisoParaVerEnvivo,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            var indexSplice;
            this.PersonasAutorizadas.find(function (val, index) {
              if (val.PermisoParaVerEnVivoId == PermisoParaVerEnVivoId) {
                indexSplice = index;
              }
            });
            this.PersonasAutorizadas.splice(indexSplice, 1);
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      darPermiso(persona) {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;
        let permiso = {
          Audiencia: {
            AudienciaId: this.AudienciaId
          },
          Usuario: {
            IdUsuario: persona.IdUsuario
          },
          Activo: true
        }

        let peticion = {
          PermisoParaVerEnVivo: permiso,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(api.conexion + api.Forseti.sistema.administracion.asignacionDePermisosParaVerEnVivo.GuardarPermiso,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {            
            this.PersonasAutorizadas.push({
              Usuario: persona
            });
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      busquedaAudiencia() {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }

        axios.post(api.conexion + api.Forseti.sistema.administracion.asignacionDePermisosParaVerEnVivo.GetAudiencia,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            //CargarDatos de audiencia
            this.Audiencia = respuesta.data.Audiencia;
            this.PersonasAutorizadas = respuesta.data.Audiencia.PermisoParaVerEnVivo;
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      busquedaPersonas() {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba
        }

        if (this.BuequedaPorNombre) {
          peticion.Nombre = this.Persona.Nombre;
          peticion.ApellidoPaterno = this.Persona.ApellidoPaterno;
          peticion.ApellidoMaterno = this.Persona.ApellidoMaterno;
        }

        if (!this.BuequedaPorNombre) {
          peticion.Email = this.Persona.Email;
        }

        axios.post(api.conexion + api.Forseti.sistema.administracion.asignacionDePermisosParaVerEnVivo.BusquedaDePersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            //CargarDatos de audiencia
            this.PersonasEncontradas = respuesta.data.Usuarios;
            console.log(this.PersonasEncontradas);
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Forseti/Administracion/AsignacionDePermisosParaVerEnVivo/AsignacionDePermisos.vue